import { render, staticRenderFns } from "./HeadingItem.vue?vue&type=template&id=908d9736&scoped=true&"
import script from "./HeadingItem.vue?vue&type=script&lang=js&"
export * from "./HeadingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908d9736",
  null
  
)

export default component.exports